export default __webpack_public_path__ + "static/studyoffice-office5-7c42a0f6d66133bc97449593d078037e.jpg";